import script from "./DeptInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeptInfo.vue?vue&type=script&setup=true&lang=ts"

import "./DeptInfo.vue?vue&type=style&index=0&id=8b862658&scoped=true&lang=scss"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b862658"]])

export default __exports__